export default {
  root: { marginBottom: '10px' },
  selectButton: {
    cursor: 'pointer'
  }
};

export const selectCustomStyles = {
  control: {
    borderRadius: '5px'
  },
  valueContainer: { width: '150px' }
};
